import { useNavigate } from 'react-router-dom';
import { ProjectForm } from '../components/projects/ProjectForm';
import { BackLink, PageHeader } from '../components/ui';

/** /projects/new. Editing an existing project is the detail page's Edit tab. */
export function ProjectEditor() {
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader
        eyebrow={<BackLink to="/projects">Projects</BackLink>}
        title="New project"
        description="Name it and pick a stage. Everything here can be changed later."
      />

      {/* Capped at the same width as the assignee form. This one used to run the
          full width of the page, which on a wide screen put a two-word label at
          one end of a 2,000-pixel row and its field at the other. */}
      <div className="mt-6 max-w-2xl">
        <ProjectForm
          onSaved={(project) => navigate(`/projects/${project.id}`)}
          onCancel={() => navigate('/projects')}
        />
      </div>
    </div>
  );
}
